import { Check, Eye, Play } from "lucide-react";
import { Link } from "../app/router";
import { useStore } from "../app/store";
import { clock } from "../app/clock";
import { FAMILY_META, describe } from "../puzzles/catalog";

export type CardStatus = "new" | "started" | "solved" | "peeked";

export function statusOf(rec: { status: string; seconds: number; state: unknown } | undefined): CardStatus {
  if (!rec) return "new";
  if (rec.status === "solved") return "solved";
  if (rec.status === "revealed") return "peeked";
  return rec.seconds > 0 || rec.state ? "started" : "new";
}

export function PuzzleCard({ id, compact = false }: { id: string; compact?: boolean }) {
  const info = describe(id);
  const rec = useStore((d) => d.progress[id]);
  if (!info) return null;
  const meta = FAMILY_META[info.family];
  const st = statusOf(rec);
  return (
    <Link to={"/p/" + id} className={`puzzle-card card st-${st}${compact ? " compact" : ""}`} data-family={info.family} aria-label={`${meta.name}: ${info.title}`}>
      <div className="pc-cover">
        <img src={meta.cover} alt="" loading="lazy" width="480" height="320" />
        <span className={"chip pc-muscle " + meta.muscle.toLowerCase()}>{meta.muscle}</span>
        {st === "solved" && <span className="pc-badge good"><Check size={16} /> Solved</span>}
        {st === "peeked" && <span className="pc-badge"><Eye size={15} /> Peeked</span>}
      </div>
      <div className="pc-body">
        <p className="pc-kicker">{meta.name} · {info.level}</p>
        <h3 className="pc-title">{info.title}</h3>
        {!compact && <p className="pc-statement">{info.statement}</p>}
        <p className="pc-foot">
          {st === "solved" ? (
            <span>{rec?.result} · {clock(rec?.seconds ?? 0)}</span>
          ) : st === "started" ? (
            <span>In progress · {clock(rec?.seconds ?? 0)}</span>
          ) : st === "peeked" ? (
            <span>You looked at the answer. Try again?</span>
          ) : (
            <span>About {info.minutes} min</span>
          )}
          <span className="pc-go"><Play size={14} /> {st === "solved" ? "Review" : st === "started" ? "Continue" : st === "peeked" ? "Retry" : "Start"}</span>
        </p>
      </div>
    </Link>
  );
}
